
import { GlobalService } from '../shared/service/global/global.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AutenticationService } from '../shared/service/autentication/autentication.service';
import staticMenuData  from '../layout/dashboard-layout/dashboard-sidebarmenu/staticData.json';
import { MenuSubMenuHeaderConfigurationService } from '@service/header-configuration/menu-sub-menu-header-configuration.service';

@Injectable()
export class MenuGuard implements CanActivate {
  staticMenuData: any=[];
  selectedMenu: any;
  constructor(
    private router: Router,
    public authService: AutenticationService,
    public globalService: GlobalService,
    private readonly menuSubMenuHeaderConfigurationService: MenuSubMenuHeaderConfigurationService
  ) {
    this.staticMenuData = staticMenuData;
  }

  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot) {
    //return true;





    // var reg = new RegExp(/ + url + /, 'g')

    // url = url.split('/').join('')
    // let index: any = this.staticMenuData.findIndex(x=> {
    //   const u = x.routerUrl.split('/').join('');
    //   const newUrlRegx = new RegExp(u);
    //   return newUrlRegx.test(url)
    // });
    //let index: any = this.staticMenuData.findIndex(x => x.routerUrl.includes(url));
    // let index: any = this.staticMenuData.findIndex(x => url.indexOf(x.routerUrl) >= 0);

    // let data = this.staticMenuData.forEach(element => {
    //   const newUrlRegx = new RegExp(element.routerUrl.split('/').join(''));
    //   if(newUrlRegx.test(url)){
    //     return element;
    //   }
    // });

     // split after 2nd slash;
    let url = state.url.replace(/(?:.*?\/){2}/, '');
    // remove slash from string
    url = url.split('/').join('')

    // Find index from staticMenu.JSON with include from URL value
    var index;
    let maxLengthMatchedUrl = 0;
    this.staticMenuData.some(function(entry, i) {
      if(entry.routerUrl != ""){
        const u = entry.routerUrl.split('/').join(''); // Remove slash from url.
        const newUrlRegx = new RegExp(u); // Make a regular expresion  with that url
        if (url.match(newUrlRegx)) {
          if (url === newUrlRegx?.source) {
            index = i;
            return true;
          } else if(newUrlRegx?.source?.length > maxLengthMatchedUrl) {
            index = i;
            maxLengthMatchedUrl = newUrlRegx?.source?.length;
          }
        }
      }
    });
    if(index != -1){
      this.selectedMenu = this.staticMenuData[index];
    }else{
      this.selectedMenu  = null;
      console.log("No Menu Found From static page");
    }

    // Get my menu from ACL local storage
    const aclMenu = this.authService.getACLMenuInfo();
    // find  selected menu is on the My acl menu list or not.
    if(this.selectedMenu){
      const aclIdx = aclMenu.findIndex(x => x.submenu_id ==  this.selectedMenu.menu_id)
      if(aclIdx != -1){
        //FOund menu
        const acl = aclMenu[aclIdx];
        this.menuSubMenuHeaderConfigurationService.setMenuInfo(acl);
        return true;
      }else{
        this.router.navigateByUrl('/dashboard');
        return false;
      }
    } else{
      this.router.navigateByUrl('/dashboard');
      return false;
    }
  }
}
